import React, { useState } from "react";
import php from "../../assets/images/php.webp";
import js from "../../assets/images/js.webp";
import sql from "../../assets/images/sql.webp";
import swift from "../../assets/images/swift.webp";
import python from "../../assets/images/python.webp";
import ccc from "../../assets/images/ccc.webp";
import type from "../../assets/images/type.webp";
import java from "../../assets/images/java.webp";
import ruby from "../../assets/images/ruby.webp";
import react from "../../assets/images/react.webp";
import lavarel from "../../assets/images/lavarel.webp";
import boot from "../../assets/images/boot.webp";
import sqlse from "../../assets/images/sqlse.webp";
import mongo from "../../assets/images/mongo.webp";
import heo from "../../assets/images/heo.svg";
import gra from "../../assets/images/gra.svg";
import goo from "../../assets/images/goo.webp";
import nodejs from "../../assets/images/nodejs.webp";
import doo from "../../assets/images/doo.webp";
import kotin from "../../assets/images/kotin.svg";
import angu from "../../assets/images/angu.webp";
import android from "../../assets/images/android.webp";
import aws from "../../assets/images/aws.webp";
import brave from "../../assets/images/brave.webp";
import codeig from "../../assets/images/codeig.webp";
import flu from "../../assets/images/flu.webp";
import gcloud from "../../assets/images/gcloud.webp";
import jque from "../../assets/images/jque.webp";
import npmm from "../../assets/images/npmm.webp";
import sass from "../../assets/images/sass.webp";
import vim from "../../assets/images/vim.webp";
import vuejs from "../../assets/images/vuejs.webp";

const tabContent = [
  {
    name: "Web Platfom",
    items: [
      { img: php, label: "PHP" },
      { img: js, label: "JavaScript" },
      { img: sql, label: "PostgreSQL" },
      { img: swift, label: "Swift" },
      { img: python, label: "Python" },
      { img: ccc, label: "C++" },
      { img: type, label: "Typescript" },
      { img: java, label: "Java" },
      { img: ruby, label: "Ruby" },
      { img: react, label: "React" },
      { img: lavarel, label: "Laravel" },
      { img: boot, label: "Bootstrap" },
    ],
  },
  {
    name: "Database",
    items: [
      { img: sqlse, label: "SQL" },
      { img: mongo, label: "Mongodb" },
      { img: sql, label: "PostgreSQL" },
      { img: heo, label: "MySQL" },
      { img: gra, label: "Graphql" },
    ],
  },
  {
    name: "Cloud & DevOps",
    items: [
      { img: goo, label: "Go" },
      { img: js, label: "JavaScript" },
      { img: nodejs, label: "NodeJS" },
      { img: doo, label: "Docker" },
      { img: python, label: "Python" },
      { img: ruby, label: "Ruby" },
    ],
  },
  {
    name: "Mobile Apps",
    items: [
      { img: java, label: "Java" },
      { img: js, label: "JavaScript" },
      { img: swift, label: "Swift" },
      { img: python, label: "Python" },
      { img: ruby, label: "Ruby" },
      { img: kotin, label: "Kotlin" },
    ],
  },
  {
    name: "Other Frameworks",
    items: [
      { img: angu, label: "Angular" },
      { img: android, label: "Android" },
      { img: aws, label: "AWS" },
      { img: brave, label: "Brave" },
      { img: codeig, label: "Codeigniter" },
      { img: flu, label: "Flutter" },
      { img: gcloud, label: "Gcloud" },
      { img: jque, label: "Jquery" },
      { img: npmm, label: "Npm" },
      { img: sass, label: "Sass" },
      { img: vim, label: "Vim" },
      { img: vuejs, label: "Vuejs" },
    ],
  },
];

export default function Tabss() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="w-full mx-auto cursor-pointer">
      <div className="grid grid-cols-2 md:grid-cols-9 p-2 cursor-pointer w-full rounded-lg bg-[#dbf4ff] lg:h-[4.875rem] items-center md:flex-row md:items-center md:justify-between ">
        {tabContent.map((tab, index) => (
          <button
            key={index}
            className={`py-2 px-4 text-sm font-medium cursor-pointer rounded-[8px] ${
              activeTab === index
                ? "bg-[#27C6FF] text-white"
                : "bg-transparent text-black"
            }`}
            onClick={() => setActiveTab(index)}
          >
            {tab.name}
          </button>
        ))}
        <button className="w-full rounded-md shadow-md border border-white border-solid bg-white flex flex-col items-center justify-center"></button>
      </div>

      {/* Content Section */}
      <div className="mt-4 p-4">
        {tabContent[activeTab]?.items && (
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-4 mx-auto items-center justify-center px-5">
            {tabContent[activeTab].items.map((item, index) => (
              <div key={index} className="flex flex-col items-center">
                <img
                  src={item.img}
                  alt={item.label}
                  className="lg:w-[8rem] lg:h-[9rem]"
                />
                <p>{item.label}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
